import {chooseSelectOption, chooseRadioOption} from "./forms";

export const cohortSelectorSupport = function (formElement, preselectValues) {
  const self = formElement

  self.determineSubjectAreaSelectorElementAndType = function () {
    if (self.subjectAreaFieldName) {
      self.subjectAreaSelectorElements = formElement.querySelectorAll(`select[name="${self.subjectAreaFieldName}"]`)
      if (self.subjectAreaSelectorElements.length) {
        self.subjectAreaSelectorType = "select"
        return true
      } else {
        self.subjectAreaSelectorElements = formElement.querySelectorAll(`input[type=radio][name="${self.subjectAreaFieldName}"]`)
        if (self.subjectAreaSelectorElements.length) {
          self.subjectAreaSelectorType = "radio"
          return true
        }
      }
    }
    console.log("Could not find subjectArea selector")
    return false
  }

  self.resetScheduleSelector = function () {
    if (self.scheduleSelectorElement) {
      self.scheduleSelectorElement.value = "";
    }

    self.resetCohortSelector()
    self.fixSafariHiddenOptions(self.scheduleSelectorElement)
  }

  self.resetCohortSelector = function () {
    if (self.cohortSelectorElement) {
      self.cohortSelectorElement.value = "";
    } else {
      return
    }
    self.fixSafariHiddenOptions(self.cohortSelectorElement)
    self.resetTimeSelector()
  }

  self.resetTimeSelector = function () {
    if (self.cohortTimeSelectorElement) {
      self.cohortTimeSelectorElement.value = "";
    }
    self.fixSafariHiddenOptions(self.cohortTimeSelectorElement)
  }

  self.disableSelector = function (element) {
    if (!element) {
      return
    }
    Array.from(element.options)
      .forEach(function (option) {
        if (option.value === '') {
          //  "Please select..."
          option.disabled = true
          option.hidden = false
          option.removeAttribute('selected')
        } else {
          option.hidden = true
        }
      })
    element.value = ''
  }

  self.disableInputSelectors = function (nodeList) {
    if (!nodeList) {
      return
    }
    nodeList.forEach(function (input) {
      input.closest('label').style.display = 'none';
      input.disabled = true;
      input.checked = false;
    })
  }

  self.disableCohortSelector = function () {
    self.disableSelector(self.cohortSelectorElement)
    self.resetCohortSelector()
  }

  self.disableTimeSelector = function () {
    self.disableSelector(self.cohortTimeSelectorElement)
    self.resetTimeSelector()
  }

  self.disableScheduleSelector = function () {
    self.disableSelector(self.scheduleSelectorElement)
    self.resetScheduleSelector()
  }

  self.hideTimeSelector = function () {
    if (self.cohortTimeSelectorElement) {
      self.cohortTimeSelectorElement.closest('.fsa__freeform__row').style.display = "none";
    }
  }

  self.showTimeSelector = function () {
    if (self.cohortTimeSelectorElement) {
      self.cohortTimeSelectorElement.closest('.fsa__freeform__row').style.display = "block";
    }
  }

  self.filterScheduleSelector = function (selectedSubjectArea) {
    const selectedValue = self.scheduleSelectorElement.value
    Array.from(self.scheduleSelectorElement.querySelectorAll('option'))
      .forEach(function (option) {
        const scheduleAvailableIn = JSON.parse(option.dataset.subjectAreas ?? "[]")
        if (option.value !== '' // don't ever hide "Please select..."
          && !scheduleAvailableIn.includes(selectedSubjectArea)) {
          option.hidden = true
          option.disabled = true
          option.removeAttribute('selected')
          if (option.value == selectedValue) {
            // if option to be hidden was selected, reset to default value
            self.resetScheduleSelector()
          }
        } else {
          option.hidden = false
          option.disabled = false
        }
      });
    self.fixSafariHiddenOptions(self.scheduleSelectorElement)
    self.selectIfOnlyOneOptionIsAvailable(self.scheduleSelectorElement)
  }

  self.filterCohortSelector = function (scheduleValue, subjectAreaValue) {
    if (!self.cohortSelectorElement) {
      return;
    }

    if (!scheduleValue || !subjectAreaValue) {
      // no filters set, disable and hide all options
      self.disableCohortSelector()
      self.disableTimeSelector()
      return;
    }

    Array.from(self.cohortSelectorElement.querySelectorAll('option'))
      .forEach(function (option) {
        if (option.value !== '' // don't ever hide "Please select..."
          && ((scheduleValue && option.dataset.schedule !== scheduleValue)
            || (subjectAreaValue && option.dataset.subjectArea !== subjectAreaValue))) {
          option.hidden = true
          option.disabled = true
          option.removeAttribute('selected')
          if (option.value == self.cohortSelectorElement.value) {
            // if option to be hidden was selected, reset to default value
            self.resetCohortSelector()
          }
        } else {
          option.hidden = false
          option.disabled = false
        }
      })

    self.fixSafariHiddenOptions(self.cohortSelectorElement)

    self.selectIfOnlyOneOptionIsAvailable(self.cohortSelectorElement)
    const cohortId = self.getSelectedCohortIdFromCohortSelector()
    self.filterCohortTimeSelector(cohortId)

    self.hideTimeSelectorIfNextAvailableCohortSelected()
  }

  self.filterCohortDateTimeSelectors = function (scheduleValue, subjectAreaValue) {
    if (self.cohortDateTimeInputs.length == 0) {
      return;
    }

    if (!scheduleValue || !subjectAreaValue) {
      // no filters set, disable all options
      self.disableInputSelectors(self.cohortDateTimeInputs);
      return;
    }

    Array.from(self.cohortDateTimeInputs)
      .forEach(function (input) {
        if ((scheduleValue && input.dataset.schedule !== scheduleValue) || (subjectAreaValue && input.dataset.subjectArea !== subjectAreaValue)) {
          input.closest('label').style.display = 'none';
          input.disabled = true;
          input.checked = false;
        } else {
          input.closest('label').style.display = '';
          input.disabled = false;
        }
      });

    self.selectIfOnlyOneInputIsAvailable(self.cohortDateTimeContainer);
  }

  self.hideTimeSelectorIfNextAvailableCohortSelected = function () {
    if (!self.cohortSelectorElement) {
      return
    }

    // conditional rendering in freeform causes the hidden fields to be not sent. And in case
    // of next available cohort the automation still needs the auto-selected cohort to be present
    // in the submitted form. So hiding/showing this field is done in JS rather than in freeform.
    // https://fullstackacademy.monday.com/boards/2335260787/pulses/3096485558/posts/1662246489
    if (self.cohortSelectorElement.value !== "Next Available Cohort") {
      self.showTimeSelector()
    } else {
      self.hideTimeSelector()
    }
  }

  self.getSelectedCohortIdFromCohortSelector = function () {
    const option = self.cohortSelectorElement.options[self.cohortSelectorElement.selectedIndex]
    return option.dataset.cohortId || null
  }

  self.filterCohortTimeSelector = function (cohortId) {
    if (!self.cohortTimeSelectorElement) {
      return
    }

    let selectedFound = false
    Array.from(self.cohortTimeSelectorElement.querySelectorAll('option'))
      .forEach(function (option) {
        if (option.value !== '' // don't ever hide "Please select..."
          && option.dataset.cohortId !== cohortId) {
          option.hidden = true
          option.disabled = true
          option.removeAttribute('selected')
        } else {
          option.hidden = false
          option.disabled = false
          if (option.value === self.cohortTimeSelectorElement.value) {
            selectedFound = true
          }
        }
      });

    self.fixSafariHiddenOptions(self.cohortTimeSelectorElement)

    if (!selectedFound) {
      // if option to be hidden was selected, reset to default value
      self.resetTimeSelector()
    }
    self.selectIfOnlyOneOptionIsAvailable(self.cohortTimeSelectorElement)
  }

  /**
   * If there's only one option available (+"select..." which is ignored), select it
   * @param element
   */
  self.selectIfOnlyOneOptionIsAvailable = function (element) {
    // if there's only one option available (Select... and the actual option), select it
    const availableOptions = element.querySelectorAll('option:not(:disabled)')
    if (availableOptions.length === 2) {
      const allOptions = element.querySelectorAll('option')

      Array.from(allOptions)
        .forEach(option => option.removeAttribute('selected'));

      Array.from(allOptions)
        .forEach(function (option) {
          if (option.value !== '' && !option.disabled) {
            // setting by selected attribute, not element.value because there can be multiple
            // options with "Next Available Cohort" and the first one, even hidden, will be selected
            // which in turn will lead to not sending this field at all.
            element.value = option.value
            element.selectedIndex = option.index
            option.setAttribute('selected', 'selected')
          }
        })
    }
    const event = new Event('change');
    element.dispatchEvent(event);
  }

  self.selectIfOnlyOneInputIsAvailable = function (container) {
    // if there's only one input available, check it
    const availableInputs = container.querySelectorAll('input:not(:disabled)')
    if (availableInputs.length === 1) {
      availableInputs[0].checked = true;
    }
    const event = new Event('change');
    availableInputs[0].dispatchEvent(event);
  }

  /**
   * Because safari doesn't support `hidden` attribute, in order to hide a select option we need
   * to wrap it in <span> for the time it's hidden
   * @param element
   */
  self.fixSafariHiddenOptions = function (element) {
    if (!(navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1)) {
      // not safari, don't do anything
      return;
    }

    Array.from(element.querySelectorAll('option'))
      .forEach((option) => {
        if (option.hidden) {
          if (!option.parentNode.classList.contains('option-hidden-wrapper')) {
            // wrap hidden option in <span> to hide in Safari
            const wrapper = document.createElement('span');
            wrapper.className = 'option-hidden-wrapper';
            option.parentNode.insertBefore(wrapper, option);
            wrapper.appendChild(option);
          }
        } else {
          // unwrap visible option from <span>
          if (option.parentNode.classList.contains('option-hidden-wrapper')) {
            let elParentNode = option.parentNode;
            if (elParentNode !== document.body) {
              elParentNode.parentNode.insertBefore(option, elParentNode);
              elParentNode.parentNode.removeChild(elParentNode);
            }
          }
        }
      });
  }

  self.getSelectedSubjectAreaValue = function () {
    switch (self.subjectAreaSelectorType) {
      case 'select':
        return self.subjectAreaSelectorElements[0].value

      case 'radio':
        const selectedOption = formElement.querySelector(`input[type=radio][name="${self.subjectAreaFieldName}"]:checked`)
        if (selectedOption) {
          return selectedOption.value
        }
    }
    return null
  }

  self.selectSubjectAreaValue = function (value) {
    switch (self.subjectAreaSelectorType) {
      case 'select':
        return window.fullstackacademy.chooseSelectOption(self.subjectAreaSelectorElements[0], value)

      case 'radio':
        return window.fullstackacademy.chooseRadioOption(self.subjectAreaSelectorElements, value)
    }
    return false
  }

  /**
   * If there's a preselected value, select it. On the first one not available (course preference, then schedule)
   * it will break the process, so we don't end up with a schedule that doesn't match the course preference.
   *
   * This could happen if user had course_preference saved in local storage, but then the course was removed.
   *
   * @param preselectValues
   */
  self.processPreselectValues = function (preselectValues) {
    if (!preselectValues) {
      return
    }

    self.subjectAreaValue = preselectValues.subjectArea || self.subjectAreaValue || preselectValues.course_preference || null

    if (self.subjectAreaValue && self.subjectAreaSelectorType) {
      if (self.selectSubjectAreaValue(self.subjectAreaValue)) {
        self.filterScheduleSelector(self.subjectAreaValue)
      } else {
        // break selecting now, because schedule selector is dependent on subject area
        return
      }
    }

    // select schedule
    self.scheduleValue = preselectValues.schedule || self.scheduleValue || preselectValues.rtc_schedule || null
    if (self.scheduleValue && self.scheduleSelectorElement) {
      const option = self.scheduleSelectorElement.querySelector('option[value="' + self.scheduleValue + '"]');
      if (option && !option.disabled) {
        self.scheduleSelectorElement.value = self.scheduleValue
      }
    }
  }

  self.handleCohortSelectorDependantFieldChange = function () {
    self.scheduleValue = self.normalizeScheduleValue(self.scheduleSelectorElement ? self.scheduleSelectorElement.value : null)
    self.subjectAreaValue = self.normalizeSubjectAreaValue(self.getSelectedSubjectAreaValue())
    self.filterCohortSelector(self.scheduleValue, self.subjectAreaValue)
  }

  self.handleCohortDateTimeSelectorDependantFieldChange = function () {
    self.scheduleValue = self.normalizeScheduleValue(self.scheduleSelectorElement ? self.scheduleSelectorElement.value : null)
    self.subjectAreaValue = self.normalizeSubjectAreaValue(self.getSelectedSubjectAreaValue())
    self.filterCohortDateTimeSelectors(self.scheduleValue, self.subjectAreaValue)
  }

  self.handleCohortSelectorChange = function () {
    if (self.cohortTimeSelectorElement) {
      const cohortId = self.getSelectedCohortIdFromCohortSelector()
      self.filterCohortTimeSelector(cohortId)
    }
  }

  self.normalizeScheduleValue = function (value) {
    return value

    // TODO, once the values are determined
    //  const translationTable = {
    //   "full-time": "full-time",
    //   "part-time": "part-time",
    //   21: "full-time",
    //   22: "part-time"
    // }
    //return translationTable[value] || value
  }

  self.normalizeSubjectAreaValue = function (value) {
    return value

    // TODO, once the values are determined
    // const translationTable = {
    //   "Coding": "coding",
    //   "Cybersecurity": "cyber",
    //   "Data Science": "data",
    //   "DevOps": "devops",
    //   "Product Management": "product-management",
    //   "ProdMan": "product-management"
    // }
    //return translationTable[value] || value
  }

  self.setInitialFormState = function (preselectValues) {
    // Prefill form
    // source 1: input attributes
    self.subjectAreaValue = null
    self.scheduleValue = null
    self.cohortDateTimeValue = null

    if (self.cohortSelectorElement) {
      self.subjectAreaValue = self.cohortSelectorElement.dataset.subjectArea || null
      self.scheduleValue = self.cohortSelectorElement.dataset.schedule || null

      // source 2 pre-set related fields values
      const scheduleFieldName = self.cohortSelectorElement.dataset.scheduleField || self.cohortSelectorElement.dataset.scheduleFieldName
      if (scheduleFieldName) {
        const scheduleField = formElement.querySelector(`[name=${scheduleFieldName}]`)
        if (scheduleField) {
          scheduleField.addEventListener('change', self.handleCohortSelectorDependantFieldChange)
          if (scheduleField.value) {
            self.scheduleValue = scheduleField.value
          }
        }
      }

      // source 3: passed params
      self.processPreselectValues(preselectValues)

      // when cohort selector changes, filter time selector
      self.cohortSelectorElement.addEventListener('change', function () {
        self.hideTimeSelectorIfNextAvailableCohortSelected()
        self.handleCohortSelectorChange()
      })
    } else if (self.cohortDateTimeContainer) {
      self.subjectAreaValue = self.cohortDateTimeContainer.dataset.subjectArea || null
      self.scheduleValue = self.cohortDateTimeContainer.dataset.schedule || null

      // source 2 pre-set related fields values
      const scheduleFieldName = self.cohortDateTimeContainer.dataset.scheduleField || self.cohortDateTimeContainer.dataset.scheduleFieldName;
      if (scheduleFieldName) {
        const scheduleField = formElement.querySelector(`[name=${scheduleFieldName}]`);
        if (scheduleField) {
          scheduleField.addEventListener('change', self.handleCohortDateTimeSelectorDependantFieldChange);
          if (scheduleField.value) {
            self.scheduleValue = scheduleField.value;
          }
        }
      }

      // source 3: passed params
      self.processPreselectValues(preselectValues)
    } else if (self.subjectAreaSelectorType) {
      self.processPreselectValues(preselectValues)
    }
  }

  // initialize references to form elements
  self.cohortSelectorElement = formElement.querySelector("[data-field-type='cohortSelector']")
  self.cohortTimeSelectorElement = formElement.querySelector("[data-field-type='cohortTimeSelector']")
  self.scheduleSelectorElement = formElement.querySelector("[data-field-type='scheduleSelector']")

  self.cohortDateTimeContainer = formElement.querySelector("[data-field-type='cohortDateTimeSelector']")
  self.cohortDateTimeInputs = self.cohortDateTimeContainer?.querySelectorAll("input")

  self.subjectAreaFieldName = self.scheduleSelectorElement.dataset.subjectAreaField || self.scheduleSelectorElement.dataset.subjectAreaFieldName || "course_preference"
  self.subjectAreaSelector = null

  // "select", "radio" or null. Use this to determine, if subject area selector is present
  self.subjectAreaSelectorType = null
  self.determineSubjectAreaSelectorElementAndType()

  // console.groupCollapsed('cohort-selector')
  // console.log([self.subjectAreaSelectorElements !== null,
  //   self.scheduleSelectorElement !== null,
  //   self.cohortSelectorElement !== null,
  //   self.cohortTimeSelectorElement !== null
  // ])
  // console.groupEnd()

  // set initial values from form params, input attributes etc.
  self.setInitialFormState(preselectValues)

  // Subject Area
  if (self.subjectAreaSelectorType) {
    // value comes from another field, add listener and filter on load in case there's a default value there
    self.subjectAreaSelectorElements.forEach(el => el.addEventListener('change', function () {
      const selectedSubjectArea = self.getSelectedSubjectAreaValue()
      self.filterScheduleSelector(selectedSubjectArea)
    }))

    // trigger the schedule filter
    self.filterScheduleSelector(self.getSelectedSubjectAreaValue())
  } else if (self.scheduleSelectorElement.dataset.subjectArea) {
    // subjectArea provided as attribute, without pointing to a subjectAreaField
    // TODO: update docs if out-of-date
    self.filterScheduleSelector(self.scheduleSelectorElement.dataset.subjectArea)
  }

  // Schedule
  if (self.scheduleSelectorElement) {
    self.scheduleSelectorElement.addEventListener('change', self.handleCohortSelectorDependantFieldChange)
    self.handleCohortSelectorDependantFieldChange()
    self.fixSafariHiddenOptions(self.scheduleSelectorElement)
  }

  // Cohort
  if (self.cohortSelectorElement) {
    // trigger post-render filter. This can be called again after subject/schedule input
    // changes assuming they are connected using input attributes
    self.filterCohortSelector(self.scheduleValue, self.getSelectedSubjectAreaValue())
    self.fixSafariHiddenOptions(self.cohortSelectorElement)

    if (preselectValues.start_date) {
      window.fullstackacademy.chooseSelectOption(self.cohortSelectorElement, preselectValues.start_date)
      self.handleCohortSelectorChange()
    }
  }

  // Cohort Time
  if (self.cohortTimeSelectorElement) {
    self.fixSafariHiddenOptions(self.cohortTimeSelectorElement)

    if (preselectValues.application_cohort_name) {
      window.fullstackacademy.chooseSelectOption(self.cohortTimeSelectorElement, preselectValues.application_cohort_name)
    }
  }

  // Cohort Date Time
  if (self.cohortDateTimeContainer) {
    // trigger post-render filter. This can be called again after subject/schedule input
    // changes assuming they are connected using input attributes
    self.filterCohortDateTimeSelectors(self.scheduleValue, self.getSelectedSubjectAreaValue())

    if (preselectValues.application_cohort_name) {
      window.fullstackacademy.chooseRadioOption(self.cohortDateTimeInputs, preselectValues.application_cohort_name)
    }

    // show container after set first available inputs
    self.cohortDateTimeContainer.style.display = ''
  }
}
